var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.msg.answerStatus === 0
    ? _c("div", { staticClass: "is-answer-loading" }, [
        _c("div", { staticClass: "is-answer-loading-text" }, [
          _vm._v(_vm._s(_vm.$t("pc_biz_ai_thinking").d("正在思考"))),
        ]),
        _vm._m(0),
      ])
    : _vm.msg.answerStatus === 2
    ? _c(
        "div",
        { staticClass: "is-content" },
        [
          _vm._v(
            _vm._s(_vm.msg.contentDetail && _vm.msg.contentDetail.content) +
              "\n    "
          ),
          _vm.settings.publicResourceEnabled
            ? _c(
                "yxt-button",
                {
                  staticClass: "internet-btn",
                  attrs: { type: "text" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("resend", "askInternet")
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("pc_biz_ai_question_tips").d("互联网问问"))
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      )
    : _c("div", { staticClass: "is-content" }, [
        _vm._v(
          "\n    " +
            _vm._s(
              (_vm.msg.contentDetail && _vm.msg.contentDetail.content) ||
                _vm.settings.assistWele ||
                _vm
                  .$t("pc_biz_ai_question_default_tips")
                  .d("你好，我是AI助手，很高兴为你服务！")
            ) +
            "\n"
        ),
      ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "answer-loading" }, [_c("div")])
  },
]
render._withStripped = true

export { render, staticRenderFns }